import styled from "styled-components";

export const SliderWrapper = styled.section`
  max-width: 48rem;
  margin: auto;
  position: relative;
  --slide-height: 19rem;
  --slide-spacing: 1rem;
  --slide-size: 100%;
`;

export const SliderViewport = styled.div`
  overflow: hidden;
`;

export const SliderContainer = styled.div`
  display: flex;
  align-items: center;
  touch-action: pan-y pinch-zoom;
`;

export const Slide = styled.div`
  flex: 0 0 var(--slide-size);
  min-width: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const Thumbs = styled.div`
  --thumbs-slide-spacing: 0.8rem;
  --thumbs-slide-height: 6rem;
  margin-top: var(--thumbs-slide-spacing);
`;

export const ThumbsViewport = styled.div`
  overflow: hidden;
`;

export const ThumbsContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: calc(var(--thumbs-slide-spacing) * -1);
`;

export const ThumbsSlide = styled.div`
  flex: 0 0 22%;
  min-width: 0;
  padding-left: var(--thumbs-slide-spacing);

  @media (min-width: 576px) {
    flex: 0 0 15%;
  }
`;

export const ThumbsSlideNumber = styled.button`
  border-radius: 1.8rem;
  -webkit-tap-highlight-color: rgba(var(--text-high-contrast-rgb-value), 0.5);
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
  touch-action: manipulation;
  display: inline-flex;
  text-decoration: none;
  cursor: pointer;
  border: 0;
  padding: 0;
  margin: 0;
  box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--detail-high-contrast);
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--thumbs-slide-height);
  width: 100%;
`;

export const DefaultButton = styled.button`
  position: absolute;
  z-index: 1;
  width: 40px;
  height: 40px;
  top: 45%;
  transform: translateY(-50%);
  border: none;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }

  &:hover:not(:disabled) {
    background-color: #3bb77e;
    color: white;
  }
`;

export const PrevButton = styled(DefaultButton)`
  left: -20px; // 캐러셀 바깥쪽에 위치
`;

export const NextButton = styled(DefaultButton)`
  right: -20px; // 캐러셀 바깥쪽에 위치
`;
